<template>
  <!--begin::Payment Listing-->
  <div class="payment-template">
    <ListingTemplate :customClass="'payment-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="false">
              <v-col cols="4" class="pt-0">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-col>
              <v-col cols="8" class="pt-0 justify-flex-end d-flex margin-auto">
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" class="pt-0 my-auto col-md-4 col-lg-6">
                <h1 class="form-title d-flex m-0">Payments</h1>
              </v-col>
              <v-col
                cols="12"
                class="col-md-8 col-lg-6 pt-0 justify-flex-end d-flex"
              >
                <v-btn
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-bold-button"
                  v-on:click="exportDialog = true"
                  color="cyan white--text"
                >
                  <v-icon dark left>mdi-database-export</v-icon> Export
                </v-btn>
                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          v-on:change="updateVisible()"
                          color="cyan"
                          hide-details
                          class="pt-2 mt-0"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <v-menu offset-y left>
                  <!--  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip top content-class="custom-top-tooltip">
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          :disabled="dataLoading"
                          class="ml-2 custom-bold-button"
                          color="cyan white--text"
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }"
                        >
                          {{ entity.name }}
                        </v-btn>
                      </template>
                      <span>Entity</span>
                    </v-tooltip>
                  </template> -->
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in entityList"
                      :key="index"
                      link
                      v-on:click="updateEntity(item)"
                    >
                      <v-list-item-title class="font-weight-600">{{
                        item.name
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <PageTips v-if="false" module="payment"></PageTips>
              </v-col>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Payment"
          :basicSearchFields="[
            'barcode',
            'unit_no',
            'street_1',
            'street_2',
            'zip_code',
          ]"
          :allowedSearchFields="allowedSearchFields"
        ></ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="
                        cols.field == 'action'
                          ? (getPermission('payment:update') || getPermission('payment:delete'))
                          : cols.visible
                      "
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{ 'checkbox-width-limit': cols.checkbox }"
                      :style="{ 'max-width': cols.width }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!dataLoading">
                  <template v-if="!lodash.isEmpty(rowData)">
                    <tr
                      v-for="(data, index) in rowData"
                      :key="index"
                      link
                      class="payment-listing-row"
                    >
                      <template v-for="cols in customThead">
                        <td
                          v-if="
                            cols.field == 'action'
                              ? (getPermission('payment:update') || getPermission('payment:delete'))
                              : cols.visible
                          "
                          :key="cols.id"
                          :class="{
                            'simple-table-td': !cols.checkbox,
                            'checkbox-width-limit': cols.checkbox,
                          }"
                          :style="{ 'max-width': cols.width }"
                          v-on:click="
                            Number(cols.checkbox) == 0
                              ? rowClicked(data)
                              : 'javascript:void(0)'
                          "
                        >
                          <template
                            v-if="cols.checkbox && Number(cols.checkbox) == 1"
                          >
                            <v-checkbox
                              dense
                              v-model="selectedRows"
                              v-bind:value="data.id"
                              color="cyan"
                              class="hide-margin"
                              hide-details
                            ></v-checkbox>
                          </template>
                          <template v-else-if="cols.field == 'barcode'">
                            <Barcode :barcode="data.barcode"></Barcode>
                          </template>
                          <!-- <template v-else-if="cols.field == 'reference'">
                            {{
                              data.reference ||
                              data.invoice?.reference ||
                              "No reference"
                            }}
                          </template> -->
                          <template v-else-if="cols.field == 'date'">
                            <p
                              class="m-0 custom-nowrap-ellipsis"
                              v-if="data.payment_date"
                            >
                              <b>Payment: </b>
                              {{ formatDate(data.payment_date) }}
                            </p>
                            <p
                              class="m-0 custom-nowrap-ellipsis"
                              v-if="data.due_date"
                            >
                              <b>Invoice Due: </b>
                              {{ formatDate(data.invoice.due_date) }}
                            </p>
                            <p
                              class="m-0 custom-nowrap-ellipsis"
                              v-if="data.sent_date"
                            >
                              <b>Invoice Sent: </b>
                              {{ formatDate(data.invoice.sent_date) }}
                            </p>
                          </template>
                          <template v-else-if="cols.field == 'company_info'">
                            <div class="payment-listing-customer">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Name: </b>
                                {{ data.billing_contact_person.display_name }}
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Company: </b>
                                {{ data.customer.display_name }}
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Email: </b>
                                {{ data.billing_contact_person.primary_email }}
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Phone: </b>
                                {{ data.billing_contact_person.primary_phone }}
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'amount'">
                            <div class="payment-listing-amount">
                              <p
                                v-if="false"
                                class="m-0 custom-nowrap-ellipsis"
                              >
                                <b>Pending: </b>
                                {{
                                  $accountingJS.formatMoney(
                                    data.invoice.pending_amount
                                  )
                                }}
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Received: </b>
                                {{ $accountingJS.formatMoney(data.amount) }}
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'invoice'">
                            <div
                              class="payment-listing-invoice"
                              v-on:click.prevent
                            >
                              <p class="m-0 custom-nowrap-ellipsis">
                                <Barcode
                                  route="invoice.detail"
                                  :id="data.invoice.id"
                                  :barcode="data.invoice.barcode"
                                >
                                </Barcode>
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'mode'">
                            <div class="payment-listing-mode">
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{
                                  data.payment_mode && data.payment_mode.text
                                }}
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'action'">
                          <template>
                            <v-btn
                              v-if="getPermission('payment:update')"
                              icon
                              color="cyan"
                              v-on:click.stop="editPayment(data)"
                            >
                              <v-icon size="20">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="getPermission('payment:delete')"
                              icon
                              color="red"
                              v-on:click.stop="deletePayment(data)"
                            >
                              <v-icon size="20">mdi-delete</v-icon>
                            </v-btn>
                          </template>
                        </template>
                          <template v-else-if="cols.field == 'created_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.added_by)"
                              :data="data"
                            >
                              <template v-slot:display_name>
                                {{ data.added_by.display_name }}
                              </template>

                              <template v-slot:date_time>
                                <template v-if="getDateCountAll(data.added_at)">
                                  {{ data.created_at }}
                                </template>
                                <template v-else>
                                  {{ formatDateTime(data.added_at) }}
                                </template>
                              </template>

                              <template v-slot:format_date_time>
                                {{ formatDateTime(data.added_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else-if="cols.field == 'updated_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.updated_by)"
                              :data="data"
                            >
                              <template v-slot:display_name>
                                {{ data.updated_by.display_name }}
                              </template>
                              <template v-slot:date_time>
                                {{ data.modified_at }}
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDateTime(data.updated_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else>
                            <div v-html="printRowData(cols, data)"></div>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr v-else-if="!dataLoading">
                    <td :colspan="15" class="py-4">
                      <p
                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                      >
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image"
                        />
                        Uhh... There are no payment at the moment.
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <ExportDialog
          :dialog="exportDialog"
          title="Export Payments"
          module="payment"
          :initialEmail="companyEmail"
          :queryParams="queryParams"
          :listingSearch="listingSearch"
          v-on:close="exportDialog = false"
        ></ExportDialog>
        <EditPaymentTemplate
          v-if="editPaymentDialog"
          :detail="selectedPaymentDetail"
          :payment-id="selectedPaymentId"
          :payment-dialog="editPaymentDialog"
          v-on:close="
            editPaymentDialog = false;
            selectedPaymentId = null;
            selectedPaymentDetail = {};
          "
          v-on:success="onPaymentUpdated"
        ></EditPaymentTemplate>
        <DeleteDialog :delete-dialog="deletePaymentDialog">
          <template v-slot:title>Delete Confirmation</template>
          <template v-slot:text>
            <h3
              class="font-weight-500 delete-text"
              style="font-size: 18px !important"
            >
              Are you sure you want to delete
              <span class="font-weight-650">{{
                selectedDeletePayment?.barcode
              }}</span>
              ?
            </h3>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="deletePaymentLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="deletePaymentDialog = false"
              >No! Cancel</v-btn
            >
            <v-btn
              depressed
              :disabled="deletePaymentLoading"
              :loading="deletePaymentLoading"
              color="red lighten-1 white--text"
              v-on:click="deletePaymentConfirm"
              class="mx-2 custom-grey-border custom-bold-button"
              >Yes! Delete</v-btn
            >
          </template>
        </DeleteDialog>
        <Dialog :commonDialog="searchDialog">
          <template v-slot:title>Filter Payment</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="6">
                    <v-menu
                      v-model="datePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Dates Range"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="dates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="formattedDate"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="dates"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <template v-for="(field, index) in searchableArray">
                    <v-col md="6" :key="index" v-if="field != 'dates'">
                      <v-text-field
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :label="getFilterLabel(field, 'Payment')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Payment Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import PaymentMixin from "@/core/lib/payment/payment.mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ExportDialog from "@/view/pages/partials/Export-Dialog.vue";
import DeleteDialog from "@/view/pages/partials/Delete";
import EditPaymentTemplate from "@/view/pages/invoice/Edit-Payment.vue";
import { saveAs } from "file-saver";
import { DELETE, DOWNLOAD } from "@/core/services/store/request.module";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import { getConfig } from "@/core/services/local.service";

// import JwtService from "@/core/services/jwt.service";

export default {
  mixins: [CommonMixin, ListingMixin, PaymentMixin],
  name: "payment-list",
  data() {
    return {
      exportDialog: false,
      exportLoading: false,
      selectedPaymentId: null,
      selectedPaymentDetail: {},
      editPaymentDialog: false,
      deletePaymentDialog: false,
      deletePaymentLoading: false,
      selectedDeletePayment: null,
      dates: [],
      customThead: [],
      pageModule: "payment-listing",
      routeAPI: "payment",
      routeName: "payment",
      routeDetailName: "payment.detail",
      status: "all",
      statusList: [],
      moreActions: [
        /*{
          title: "Export Payment(s)",
          action: "export_items",
          divider: false,
          icon: "mdi-database-export",
        },*/
        /*{
          title: "Export Current View",
          action: "export_current_view",
          divider: true,
          icon: "mdi-database-export",
        },*/
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      bulkActions: [
        {
          title: "Mark as Paid",
          action: "mark_as_paid",
          icon: "mdi-currency-usd",
        },
        {
          title: "Mark as Unpaid",
          action: "mark_as_unpaid",
          icon: "mdi-currency-usd-off",
        },
        {
          title: "Mark as Draft",
          action: "mark_as_draft",
          icon: "mdi-archive",
        },
        { title: "Delete", action: "delete", icon: "mdi-delete" },
        { title: "Download PDF", action: "download_pdf", icon: "mdi-file-pdf" },
        { title: "Print", action: "print", icon: "mdi-printer" },
      ],
    };
  },
  components: {
    draggable,
    PageTips,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    ExportDialog,
    DeleteDialog,
    EditPaymentTemplate,
  },
  computed: {
    canManagePayments() {
      return (
        this.getPermission("payment:update") ||
        this.getPermission("payment:delete")
      );
  },
  },
  methods: {
    columnLength() {
      const visibleColumns = this.defaultColDefs.filter(
        (column) =>
          Number(column.visible) === 1 &&
          (column.field !== "action" || this.canManagePayments)
      );
      return visibleColumns.length;
    },
    editPayment(row) {
      this.selectedPaymentId = row.id;
      this.selectedPaymentDetail = row.invoice || {};
      this.editPaymentDialog = true;
    },
    onPaymentUpdated() {
      this.getRows();
    },
    deletePayment(row) {
      this.selectedDeletePayment = row;
      this.deletePaymentDialog = true;
    },
    deletePaymentConfirm() {
      this.deletePaymentLoading = true;
      this.$store
        .dispatch(DELETE, {
          url: `payment/${this.selectedDeletePayment.id}`,
        })
        .then(() => {
          this.deletePaymentDialog = false;
          this.selectedDeletePayment = null;
          this.getRows();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deletePaymentLoading = false;
        });
    },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          break;
        case "export_items":
          _this.bulkPaymentExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("payment");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
    bulkPaymentExport() {
      const _this = this;
      let fileName = new Date();
      _this.exportLoading = true;
      _this.$store
        .dispatch(DOWNLOAD, {
          url: "payment/export",
        })
        .then(({ data }) => {
          saveAs(data, "leave-export-" + fileName.getTime() + ".xlsx");
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.exportLoading = false;
        });
    },
  },
  mounted() {
    this.companyEmail = getConfig("company_email") || "";
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Payment",
      },
    ]);
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.applyColState();

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 10;
  },
};
</script>
